module.exports = __webpack_public_path__ + "cc3d4825504f978d6df69dd0b5c0e035.svg";